export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 80,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_hxSkuNo') || '产品SKU编号',
    field: 'hxSkuNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_channelItemNo') || '渠道Item号',
    field: 'channelItemNo',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        style: 'width:100%',
        maxlength: 50,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('INDEX.form_label_channelEanNo') || '渠道条码号',
    field: 'channelEanNo',
    width: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        style: 'width:100%',
        maxlength: 50,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_brand') || '品牌',
    field: 'brandCode',
    minWidth: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'dict-select',
      props: {
        url: '/master/common/dict/brandSelect',
        filterable: true,
        clearable: true,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_salesTitle') || '店铺售卖标题',
    field: 'salesTitle',
    minWidth: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        style: 'width:100%',
        maxlength: 1000,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_salesPrice') || '正常卖价',
    field: 'salesPrice',
    width: 140,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        min: 0,
        step: 0.01,
        precision: 2,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_salesCurrencyUnit') || '结算货币单位',
    field: 'salesCurrencyUnit',
    width: 140,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'dict-select',
      props: {
        body: { dictType: 'currencyUnit' },
        url: '/master/common/dict/biz',
        filterable: true,
        clearable: true,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('INDEX.form_label_sellableEachQty') || '最小出货入数',
    field: 'sellableEachQty',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        min: 0,
        step: 1,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('INDEX.form_label_sellableEachUnit') || '最小出货单位',
    field: 'sellableEachUnit',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'dict-select',
      props: {
        body: { dictType: 'sellableEachUnit' },
        url: '/master/common/dict/biz',
        filterable: true,
        clearable: true,
        size: 'mini',
      },
    },
  },
]
